import { parseURLParams, stringifyURLParams } from '@offerzen/pinata-shame'

/**
 * Adds or replaces query parameters in a query string
 * @param {string} queryString — The query string to which the parameters will be added or replaced, e.g. 'param1=value1&param2=value2'
 * @param {object} paramsToUpdate — The parameters to be added or replaced, e.g. { param1: 'value1', param2: 'value2' }
 * @returns {string} — The updated query string with the specified parameters added or replaced
 */
export const updateQueryParams = (queryString, paramsToUpdate) => {
  const params = { ...parseURLParams(queryString), ...paramsToUpdate }
  return stringifyURLParams(params)
}
